<template>
  <transition name="fade">
    <div class="detail" v-if="visible">
      <div class="detail-shadow" @click="hidePopup"></div>
      <div class="detail-main">
        <product-item
          :item="product"
          :isPreProduct="false"
          :isDetailPopup="true"
        ></product-item>
        <hr class="line" />
        <div class="package">
          <span
            class="package-item"
            v-for="(item, index) in packageList"
            :key="index"
            >{{ item.NAME }}x{{ item.COUNT }}</span
          >
        </div>
        <div class="btn-wrap">
          <template v-if="onlyDetail">
            <div class="btn close" @click="manualClose">
              {{ letter.popupClose }}
            </div>
          </template>
          <template v-else>
            <div class="btn" @click="later">{{ letter.thinkLater }}</div>
            <div class="btn active" @click="selectProduct">
              {{ letter.confirmBuy }}
            </div></template
          >
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapMutations, mapState, mapGetters } from 'vuex';
import globalConfig from '@utiles/officialStore/globalConfig';
import { locationType, clickButton } from '@plugins/biPoint/_configWebstoreV2';
import ProductItem from '@components/officialWebStore/product/ProductItem.vue';
export default {
  name: 'ProductDetailPopup',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    product: {
      type: Object,
      default: () => ({})
    },
    onlyDetail: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  },
  computed: {
    ...mapState({
      letter: state => state.letter,
      lang: state => state.lang
    }),
    ...mapGetters(['gameInfoConfig']),
    packageList() {
      return this.product?.CP_PRODUCT_EXT?.CONTENT || [];
    }
  },
  methods: {
    hidePopup() {
      this.$emit('update:visible', false);
    },
    selectProduct() {
      clickButton({
        btnName: 'select_product',
        locationKey: locationType.selectProduct
      });
      this.$emit('selectProduct', this.product);
      this.hidePopup();
    },
    later() {
      clickButton({
        btnName: 'not_select_product',
        locationKey: locationType.selectProduct
      });
      this.hidePopup();
    },
    manualClose() {
      clickButton({
        btnName: 'close_product_detail',
        locationKey: locationType.selectProduct
      });
      this.hidePopup();
    }
  },
  components: {
    ProductItem
  }
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/officialWebStore/_dimen.scss';
.detail {
  z-index: 9;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  &-shadow {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba($color: #000000, $alpha: 0.4);
  }
  &-main {
    overflow: hidden;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -64%);
    width: 708px;
    box-sizing: border-box;
    background: #ffffff;
    border-radius: 10px;
    border: 2px solid $borderActive;
    &-close {
      position: absolute;
      right: 32px;
      top: 27px;
      background: url($tmslgImg + 'close.png') no-repeat;
      width: 28px;
      height: 28px;
      cursor: pointer;
    }
    .line {
      border: none;
      height: 2px;
      width: 674px;
      background-color: $border;
      margin: 0 auto 20px;
    }
    .package {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 10px;
      font-size: 22px;
      color: #333333;
      width: 674px;
      margin: 0 auto;
      &-item {
        line-height: 30px;
      }
    }
    .btn-wrap {
      width: 674px;
      margin: 40px auto 10px;
      display: flex;
      justify-content: space-between;
      .btn {
        display: flex;
        justify-content: center;
        align-items: center;
        line-height: 80px;
        height: 80px;
        font-size: 26px;
        border-radius: 10px;
        width: 300px;
        cursor: pointer;
        color: #fff;
        background: #fff;
        color: #333333;
        border: 1px solid $border;
        &.active {
          color: #fff;
          background: $btnBg;
          border: none;
        }
        &.close {
          width: 100%;
        }
      }
    }
  }
}
@media screen and (orientation: landscape) {
  .detail-main {
    width: $landscapePopupWidth;
    .package {
      font-size: 16px;
    }
    .btn-wrap .btn {
      font-size: 18px;
      line-height: 39px;
      height: 39px;
      border-radius: 30px;
    }
  }
}
</style>
